import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

    public startTimer = new Subject();
    public stopTimer = new Subject();
    public setTimer = new Subject();

  constructor() { }
}
